import { useEffect } from 'react';

import { addLoaderAction, removeLoaderAction, setColorProfileLoadedAction } from 'editor/src/store/app/slice';
import { LoaderType } from 'editor/src/store/app/types';
import getDesignColorSpace from 'editor/src/store/design/selector/getDesignColorSpace';
import { ColorSpace } from 'editor/src/store/design/types';
import { useDispatch, useSelector } from 'editor/src/store/hooks';

import { captureException } from 'editor/src/logger';

import { getModule, loadLittleCMSModule } from './cmykUtils/littleCMSModule';

function useSetupColorConversion() {
  const dispatch = useDispatch();
  const isCMYKColorSpace = useSelector((state) => getDesignColorSpace(state) === ColorSpace.CMYK);
  const cmykOnly = useSelector((state) => state.hostSettings.cmykOnly);

  useEffect(() => {
    if (!isCMYKColorSpace) {
      return;
    }
    if (!cmykOnly) {
      void loadLittleCMSModule();
      return;
    }
    // Lets what was converted with the fallback, or read against it, be worked out again.
    const markLoaded = () => dispatch(setColorProfileLoadedAction());
    if (getModule()) {
      void loadLittleCMSModule().then(markLoaded);
      return;
    }

    // A locked design starts in CMYK, so pickers wait for the profile as a switch to CMYK does.
    dispatch(addLoaderAction(LoaderType.ColorSpaceSwitch));
    loadLittleCMSModule()
      .then(markLoaded)
      .catch(captureException)
      .finally(() => dispatch(removeLoaderAction(LoaderType.ColorSpaceSwitch)));
  }, [isCMYKColorSpace, cmykOnly]);
}

export default useSetupColorConversion;
